module.exports = __webpack_public_path__ + "img/item-smart-phones-2.cc0a0fef.jpg";